var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8D8D8D",
    clipPath: "url(#copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.704a.57.57 0 0 0 0 .762c.814.873.814 2.294 0 3.167L5.22 16.22a1.994 1.994 0 0 1-2.954 0l-.642-.688c-.814-.873-.814-2.294 0-3.166l4.28-4.588a.57.57 0 0 0 0-.762.482.482 0 0 0-.712 0l-4.28 4.587A3.403 3.403 0 0 0 0 13.946c0 .888.321 1.72.907 2.344l.642.688a2.976 2.976 0 0 0 2.187.967c.79 0 1.586-.324 2.186-.967l4.28-4.587c1.206-1.292 1.206-3.401 0-4.692a.468.468 0 0 0-.702.005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.065 1.675-.642-.688a2.958 2.958 0 0 0-4.378 0l-4.28 4.588c-1.205 1.29-1.205 3.4 0 4.692.195.209.512.209.712 0a.57.57 0 0 0 0-.763c-.814-.873-.814-2.294 0-3.167l4.28-4.587a1.994 1.994 0 0 1 2.954 0l.642.688c.814.873.814 2.294 0 3.166l-4.28 4.588a.57.57 0 0 0 0 .763.47.47 0 0 0 .707 0l4.28-4.588c.587-.628.908-1.46.908-2.343 0-.888-.317-1.72-.903-2.349"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgCopy;